import React, { useMemo } from 'react';
import { Alert, Level } from './alert';
import { AlertCollapsible } from './alert-collapsible';
import { AlertLevel } from '@/types';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

interface Alert {
  alert_level: AlertLevel;
  alert_message: string;
}

const ORDER_ALERT_LEVEL_TO_ALERT_LEVEL_MAP: {
  [level in AlertLevel]: Level;
} = {
  [AlertLevel.Info]: Level.INFO,
  [AlertLevel.Negative]: Level.NEGATIVE,
  [AlertLevel.Positive]: Level.POSITIVE,
  [AlertLevel.Warning]: Level.WARNING,
};

interface Props {
  alerts: Alert[];
  containerStyle?: StyleProp<ViewStyle>;
}

export const CollapsibleAlerts: React.FC<Props> = ({
  alerts,
  containerStyle,
}) => {
  const alertComponents = useMemo(() => {
    return alerts.map(({ alert_level, alert_message }, index) => {
      const alertLevel = ORDER_ALERT_LEVEL_TO_ALERT_LEVEL_MAP[alert_level];

      if (
        (alertLevel === Level.NEGATIVE || alertLevel === Level.WARNING) &&
        alert_message.indexOf('\n\n') !== -1
      ) {
        const alertMessagesArray = alert_message.split('\n\n');
        return (
          <View key={index} style={styles.alertContainer}>
            <AlertCollapsible
              level={alertLevel}
              message={alertMessagesArray[1]}
              title={alertMessagesArray[0]}
            />
          </View>
        );
      }
      return (
        <View key={index} style={styles.alertContainer}>
          <Alert level={alertLevel}>{alert_message}</Alert>
        </View>
      );
    });
  }, [alerts]);

  return alertComponents.length ? (
    <View style={containerStyle}>{alertComponents}</View>
  ) : null;
};

const styles = StyleSheet.create({
  alertContainer: {
    marginHorizontal: 8,
    marginVertical: 4,
  },
});
